import { buttonIds } from './button-ids';
import { KavaClickTypes } from './kava-click-types';

export const buttonInfo = {
  [buttonIds.overviewAddPlan]: KavaClickTypes.Navigate,
  [buttonIds.planUpdatePlan]: KavaClickTypes.Open,
  [buttonIds.planUpdatePlanCancel]: KavaClickTypes.Close,
  [buttonIds.planUpdatePlanRequest]: KavaClickTypes.Add,
  [buttonIds.planUnsubscribe]: KavaClickTypes.Open,
  [buttonIds.planUnsubscribeKeep]: KavaClickTypes.Close,
  [buttonIds.planUnsubscribeRequest]: KavaClickTypes.Choose,
  [buttonIds.changeBillingInformation]: KavaClickTypes.Open,
  [buttonIds.changeBillingInformationCancel]: KavaClickTypes.Close,
  [buttonIds.changeBillingInformationApply]: KavaClickTypes.Save,
  [buttonIds.changePaymentMethod]: KavaClickTypes.Open,
  [buttonIds.changePaymentMethodCancel]: KavaClickTypes.Close,
  [buttonIds.changePaymentMethodApply]: KavaClickTypes.Save,
  [buttonIds.downloadInvoice]: KavaClickTypes.Choose,
  [buttonIds.addonPlanUpdate]: KavaClickTypes.Open,
  [buttonIds.addonPlanUpdateCancel]: KavaClickTypes.Close,
  [buttonIds.addonPlanUpdateRequest]: KavaClickTypes.Add,
  [buttonIds.addonUnsubscribe]: KavaClickTypes.Open,
  [buttonIds.addonUnsubscribeKeep]: KavaClickTypes.Close,
  [buttonIds.addonUnsubscribeRequest]: KavaClickTypes.Choose,
  [buttonIds.planOverview]: KavaClickTypes.Navigate,
  [buttonIds.billingDetails]: KavaClickTypes.Navigate,
  [buttonIds.invoiceHistory]: KavaClickTypes.Navigate,
  [buttonIds.accountName]: KavaClickTypes.Choose,
  [buttonIds.overviewLogout]: KavaClickTypes.Navigate,
  [buttonIds.overviewLogin]: KavaClickTypes.Navigate,
  [buttonIds.login]: KavaClickTypes.Navigate,
  [buttonIds.forgotPassword]: KavaClickTypes.Navigate,
  [buttonIds.signUp]: KavaClickTypes.Navigate,
  [buttonIds.getStartedContinue]: KavaClickTypes.Navigate,
  [buttonIds.getStartedLogin]: KavaClickTypes.Navigate,
  [buttonIds.createAccount]: KavaClickTypes.Create,
  [buttonIds.purchaseContinue]: KavaClickTypes.Navigate,
  [buttonIds.checkoutPurchaseNow]: KavaClickTypes.Create,
  [buttonIds.confirmedLogin]: KavaClickTypes.Navigate,
  [buttonIds.addOns]: KavaClickTypes.Choose,
  [buttonIds.resendVerification]: KavaClickTypes.Navigate,
};
